
import afMessages from '../locales/af-AF';

const AfLang = {
    messages: {
        ...afMessages
    },
    locale: 'af-AF',
  
};
export default AfLang;